import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-pixtral-image',
  templateUrl: './pixtral-image.component.html',
  styleUrls: ['./pixtral-image.component.scss']
})
export class PixtralImageComponent {
  constructor(private dialogRef: MatDialogRef<PixtralImageComponent>) {}

  close() {
    this.dialogRef.close();
  }
}
